import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material';

/**
 * Exported in case we want to make sweeping changes to the skeleton component.
 */
export default function Skeleton(props: SkeletonProps) {
  return <MuiSkeleton {...props} />;
}
